(function ($) {
    'use strict';

    /**
     * Initialize Slick-Slider
     *
     * For more than one Slider on a single page, the first slider (idx === 0) gets a default paging, the next slider get a customPaging
     */
    function initSlickSlider() {
        var prep = "of";
        if ($('html')[0].lang === 'de-DE') prep = "von";

        $('.js-slider').each(function (idx) {
            var carouselId = "carousel" + idx;
            this.id = carouselId;

            $(this).slick({
                centerMode: true,
                infinite: true,
                centerPadding: '20%',
                slidesToShow: 1,
                variableWidth: true,
                dots: true,
                appendArrows: $('.m-slick-navigation-' + idx),
                prevArrow: '<div class="m-slick-navigation__arrow m-slick-navigation__arrow--left p-border-color--highlight"></div>',
                nextArrow: '<div class="m-slick-navigation__arrow m-slick-navigation__arrow--right p-border-color--highlight"></div>',
                customPaging: function (slider, i) {
                    if (idx === 0) {
                        return $('<button type="button" />').text(i + 1);
                    } else {
                        return (i + 1) + ' ' + prep + ' ' + slider.slideCount;
                    }
                },
                responsive: [
                    {
                        breakpoint: 831,
                        settings: {
                            centerMode: false,
                            variableWidth: false
                        }
                    }
                ]
            });
        });
    }

    jQuery(document).ready(function () {
        initSlickSlider();
    });

})(jQuery); // This allows us to use '$' in place of 'jQuery' in our code. This is required especially for Wordpress.

